<template>
  <div class="content">
    <BlockUI
      v-if="this.blockScreen"
      :url="blockScreenData.url"
      :message="blockScreenData.msg"
    />

    <v-card>
      <v-card-title>
        <TitleWithButton
          title="Fornecedores"
          buttonText="Informar Fornecedor"
          :buttonFunction="newMaintenance"
        />
      </v-card-title>

      <v-card-subtitle>
        <v-flex class="mt-2">
          
        </v-flex>
      </v-card-subtitle>

      <v-divider />

      <v-card-text>
        <v-flex class="mx-3 my-2" xs12 md12>
          <v-row justify="start">
            <v-col align="start">
              <v-data-table
                ref="myTable"
                :headers="headers"
                :items="supplierData"
                item-key="name"
                group-key="category"
                class="elevation-1 mt-2"
                :footer-props="{
                  'items-per-page-text': 'Linhas por página:',
                }"
                no-data-text="Nenhum fornecedor cadastrado"
              >
                <template v-slot:item="{ item }">
                  <tr>
                    <td>{{ item.description }}</td>
                    <td>{{ item.responsible }}</td>
                    <td>{{ item.phone }}</td>
                    <td>{{ item.email }}</td>
                    <td>{{ item.address }}</td>
                    <td>{{ item.observation }}</td>
                    <td>
                      <ActionButton
                        v-if="situation == true"
                        message="Editar fornecedor"
                        icon="edit"
                        @onclick="editItem(item)"
                      />
                      <ActionButton
                        v-if="situation == true"
                        message="Excluir fornecedor"
                        icon="delete"
                        color="error"
                        @onclick="changeService(item, 'delete')"
                      />
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-flex>
      </v-card-text>
    </v-card>

    <v-layout justify="center">
      <v-dialog v-model="supplier_modal" persistent max-width="400px">
        <v-card>
          <v-card-title>
            <span class="headline">{{
              this.supplier.id ? 'Editar fornecedor' : 'Novo fornecedor'
            }}</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-layout wrap>
                <v-flex xs12 sm12 md12>
                  <v-text-field label="Nome *" v-model="supplier.description" required>
                  </v-text-field>                  
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <v-text-field label="Responsavel" v-model="supplier.responsible" required>
                  </v-text-field>                  
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <v-text-field label="Telefone" v-mask="telmask" v-model="supplier.phone" required>
                  </v-text-field>                  
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <v-text-field label="Email" v-model="supplier.email" required>
                  </v-text-field>                  
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <v-text-field label="Endereço" v-model="supplier.address" required>
                  </v-text-field>                  
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <v-text-field label="Observação" v-model="supplier.observation" required>
                  </v-text-field>                  
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="supplier_modal = false"
              >Cancelar</v-btn
            >
            <v-btn color="blue darken-1" text @click="formMaintenance()"
              >Salvar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <modalPadrao
        :showModal="modalConfirmacao.open"
        :ifTitle="true"
        :Title="modalConfirmacao.title"
        :ifTwoBtn="true"
        :TextFirstBtn="'Não'"
        :TextSecondBtn="'Sim'"
        @btnUm="modalConfirmacao.open = false"
        @btnDois="actionModalConfirmacao"
      ></modalPadrao>
    </v-layout>
  </div>
</template>

<script>
import XLSX from 'xlsx';
import { blockScreenUi } from '../../helpers/BlockScreenUi';
import { Datetime } from 'vue-datetime';
import MaintenanceController from '../../controllers/MaintenanceController';
import SupplierController from '../../controllers/SupplierController';
import ConfigurationController from '../../controllers/ConfigurationController';
import VehicleController from '../../controllers/VehicleController';
import ClientController from '../../controllers/ClientController';
import moment from 'moment';
import Constants from '../../models/constants/Constants';
import ActionButton from '../shared/ActionButtonsTemplate';
import TitleWithButton from '../../UIComponents/titleWithButton.vue';
import modalPadrao from '../shared/ModalPadrao.vue';

export default {
  components: {
    Datetime,
    ActionButton,
    TitleWithButton,
    modalPadrao,
  },
  data() {
    return {
      maintenanceController: new MaintenanceController(this.$resource),
      supplierController: new SupplierController(this.$resource),
      configurationController: new ConfigurationController(this.$resource),
      vehicleController: new VehicleController(this.$resource),
      clientController: new ClientController(this.$resource),
      clienteId: localStorage.getItem('client_id'),
      blockScreenData: blockScreenUi.blockScreenData,
      blockScreen: false,
      supplierData: [],
      clients: [],
      vehicles: [],
      carServiceType: [],
      situation: true,
      searchPlate: null, //id do veículo
      searchServiceTypeId: null, //id do condomínio
      supplier: {},
      headers: [
        { text: 'Nome', value: 'description' },
        { text: 'Responsavel', value: 'responsible' },
        { text: 'Telefone', value: 'phone' },
        { text: 'Email', value: 'email' },
        { text: 'Endereço', value: 'address' },
        { text: 'Obeservação', value: 'observation' },
        { text: 'Ações', value: 'action', sortable: false },
      ],
      supplier_modal: false,
      modalConfirmacao: {
        open: false,
        title: '',
        action: '',
      },
      properties: {
        'prepend-icon': 'mdi-currency-brl',
      },
      options: {
        locale: 'pt-BR',
        length: 8,
        precision: 2,
      },
      money: {
        decimal: ',',
        thousands: '.',
        precision: 2,
        masked: true,
      },
      telmask: '(##) #####-####'
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    changeService(item, action) {
      this.actionItem = item;
      this.action = action;
      this.modalConfirmacao.title = 'Deseja excluir o registro de fornecedor?';
      this.modalConfirmacao.action = action;
      this.modalConfirmacao.open = true;
    },
    async actionModalConfirmacao() {
      switch (this.action) {
        case 'finish':
          return this.finishMaintenance();
        case 'delete':
          return this.deleteSupplier();
      }
    },
    dateNow() {
      const begin = new Date();
      begin.setHours(begin.getHours());
      return moment(begin).toISOString(true);
    },
    async formMaintenance() {
      if (this.supplier.id) {
        this.updateSupplier();
        return;
      }
      this.createSupplier();
    },
    async loadData({ withFilters = false } = {}) {
      this.supplierData = [];
      this.blockScreen = true;

      this.supplierController
        .getAllSupplier({
          serviceTypeId: withFilters ? this.searchServiceTypeId : null,
          vehicleId: withFilters ? this.searchPlate : null,
          situation: this.situation,
        })
        .then(
          response => {
            if (response.body.length > 0) {
              this.supplierData = response.body;
            }
          },
          err => console.log(err)
        );

      this.blockScreen = false;
    },
    validaForm(value){
      console.log(value)
      if( !value.hasOwnProperty('description') || value.description == ''){
        this.$awn.alert('Preencha todos os campo obrigatórios "*".');
        return false;
      }
        return true;
    },
    filter() {
      this.loadData({
        withFilters: true,
      });

      this.searchPlate = null;
      this.searchServiceTypeId = null;
    },
    newMaintenance() {
      //Limpa formulário
      this.supplier = {};
      this.supplier_modal = true;
    },
    editItem(item) {
      this.supplier.id = item.id;
      this.supplier.description = item.description;      
      this.supplier_modal = true;
    },
    formtAmount(vl){
      return vl.replace('.','').replace(',','');
    },
    async createSupplier() {
      try {
        if( !this.validaForm(this.supplier) ){
          return;
        }
        
        let response = await this.supplierController.createSupplier(
          this.supplier
        );
        this.supplier_modal = false;
        this.loadData();
        if (response.body.message)
          return this.$awn.success(response.body.message);
        return this.$awn.success('Fornecedor criada com sucesso');
      } catch (err) {
        this.$awn.alert(err.body);
      }
    },
    async updateSupplier() {
      try {
        if( !this.validaForm(this.supplier) ){
          return;
        }
        
        let response = await this.supplierController.updateSupplier(
          this.supplier
        );
        this.supplier_modal = false;
        this.loadData();
        if (response.body.message)
          return this.$awn.success(response.body.message);
        return this.$awn.success('Fornecedor alterada com sucesso');
      } catch (err) {
        this.$awn.alert(err.body);
      }
    },
    async deleteSupplier() {
      try {
        await this.supplierController.deleteSupplierById(
          this.actionItem.id
        );
        this.loadData();
        this.modalConfirmacao.open = false;
        return this.$awn.success('Fornecedor excluída com sucesso');
      } catch (err) {
        this.$awn.alert('Falha ao excluir fornecedor');
        console.log(err);
      }
    },
    exportToExcel() {
      const sheet = XLSX.utils.table_to_sheet(this.$refs.myTable.$el);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, sheet, 'Tabela');
      XLSX.writeFile(workbook, 'dados.xlsx');
    }
  },
  filters: {
    formatDate(dateString) {
      if (dateString) {
        return moment(dateString).format('DD[/]MM[/]YYYY HH:mm');
      }
      return 'Sem data';
    },
    formatBoolean(value) {
      return value ? 'SIM' : 'NÃO';
    },
    formatValue(value) {
      let valueFloat = parseFloat(value / 100);
      let formatedValue = 'R$ ' + valueFloat.toFixed(2).replace('.', ',');
      return formatedValue;
    },
  },
};
</script>

<style scoped>
.inputs >>> #inputDate {
  width: 100%;
  text-align: center;
}

.menu {
  position: fixed;
  top: 0px;
  z-index: 1;
}
.colorSelectedBack {
  background-color: var(--secondary-color);
}
.sizeTop {
  height: 48px;
}

hr {
  width: 2px;
  height: 25px;
  margin: auto 0;
}

.button {
  margin: 0 auto;
}

.button-text {
  text-transform: none;
}

.second {
  margin-bottom: 46px;
}

.sizePart {
  width: 49%;
  text-align: center;
}

.cardBottom {
  position: absolute;
  bottom: 56px;
  border-radius: 0;
}

.cardRadius {
  border-radius: 4px;
}

.carSelected {
  border: 2px solid var(--secondary-color) !important;
}

.cardTitle {
  font-size: 18px;
}

.cardContent {
  display: flex;
  justify-content: space-between;
}

.creditCard {
  display: inline-flex;
}

.coupon {
  display: flex;
}

.couponBtn {
  outline: none;
}

.vehicle {
  display: flex;
}

.modelo {
  font-size: 16px;
  color: #181f4d;
}

.caption {
  color: #181f4d;
}

.contentLeft {
  display: inline-block;
  width: 60%;
}

.contentRight {
  display: inline-block;
  width: 40%;
}

.vehicleImg {
  margin-left: -10px;
}
.autocomplete__inputs input {
  height: 44px !important;
}
.vdatetime {
  width: 100%;
}

.inputs {
  border: 1px solid rgb(173, 173, 173);
  border-radius: 6px;
  align-content: middle;
  width: 90%;
  margin: 0 auto;
  display: flex;
}

.border {
  border: 2px solid grey;
}

.borderBottom {
  border-bottom: 1px solid gray;
}

.bottom {
  margin-bottom: 60px;
}

.fab {
  position: fixed;
  bottom: 0;
  width: 100%;
  margin: 0 0;
  display: flex;
}

.floatBtn {
  position: absolute;
  bottom: 56px;
  width: 100%;
  margin: 0 auto;
}

.colorBtn {
  background-color: var(--primary-color) !important;
}

.checkin {
  background-color: var(--secondary-color);
}

.checkin-text {
  color: var(--secondary-color);
}

.checkinBorder {
  border: 1px solid var(--secondary-color) !important;
}

.checkout {
  background-color: var(--orange-color) !important;
}

.checkout-text {
  color: var(--orange-color);
}

.checkoutBorder {
  border: 1px solid var(--orange-color) !important;
}

.total {
  color: #181f4d;
}
</style>
